<template>
	<div class="weixin-tip">
		<div class="weixin-top">
			<img src="../assets/images/weixin-arrow.png" alt="">
		</div>
		<div class="weixin-bot">{{ note }}</div>
	</div>
</template>

<script>
export default {
	props: {
		note: {
			type: String,
			default: '请点击右上角选择“在浏览器打开”'
		}
	}
}
</script>

<style lang="less" scoped>
.weixin-tip{
	text-align: center;
	.weixin-top{
		text-align: right;
		img{
			width: 49px;
			height: 58px;
			margin-right: 30px;
			margin-top: 16px;
			margin-bottom: 10px;
		}
	}
	.weixin-bot{
		display: inline-block;
		background: #FCF1F0;
		border-radius: 100px;
		font-size: 16px;
		color: #942618;
		padding: 14px 20px;
	}
}
</style>
